import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import "@id-express/global-user-navigation/dist/GlobalUserNavigation.css";
import App from "./App";
import {AuthProvider} from "./contexts/AuthContext";
import "./styles.css";
createRoot(document.getElementById("root")!).render(<React.StrictMode><AuthProvider><App /></AuthProvider></React.StrictMode>);
